// extracted by mini-css-extract-plugin
module.exports = {"container":"_1pquxMsyVVhc-2wAR_pQVQ","breakLogo":"_3CzxvcLPUrCjuGi-rJy2B6","text":"_2oaRvZY7ns8A4v3Xpko8RP","link":"_2XFNibStIQOdfuUhsTQsZQ","dashboard":"_2Do5XF0-aN6SLZ-IzY4Xf6"};